/* eslint-disable @nx/enforce-module-boundaries */
import { API_ENDPOINTS } from "packages/novous_web/src/api/endpoints";
import useApiError from "packages/novous_web/src/api/useApiError";
import { FcwIotDeviceByDeviceId, getUserDataForMaskingReact } from "packages/novous_web/src/utils/apihelper";
import React, { JSX, useEffect, useState } from "react";
import { useAuth } from "packages/novous_web/src/authContext/useAuth";
import { bool } from "aws-sdk/clients/signer";

interface OverlaySection {
    top: number;
    left: number;
    width: number;
    height: number;
}

function VideoOverlay({ streamUrl, availableWidth, deviceId, customerId, setBlurStatus, sdVideo, fullMode, singleFullMode, mlParams, onOverlayReady, playerSize, tableBlur = false, fetchBlurFalse = false, blurEnable, deviceType }: {
    streamUrl: any;
    deviceId: any;
    customerId: any;
    sdVideo: any;
    fullMode: any;
    setBlurStatus?: any;
    singleFullMode: any;
    availableWidth?: any;
    mlParams: any;
    onOverlayReady: (value: boolean) => void;
    playerSize: any;
    tableBlur?: boolean;
    fetchBlurFalse?: boolean;
    blurEnable?: boolean; // Added fetchBlurFalse prop
    deviceType?: string
}): JSX.Element {
    const { user } = useAuth();
    const [overlaySections, setOverlaySections] = useState<OverlaySection[]>([]);
    const [applyOverlay, setApplyOverlay] = useState<boolean>(false);
    const [videoReady, setVideoReady] = useState<boolean>(false);
    const [videoSize, setVideoSize] = useState({ videoWidth: window.innerWidth, videoHeight: window.innerHeight });
    // and videoDimensions()

    const videoWidth = playerSize && playerSize?.width;
    const videoHeight = playerSize && playerSize?.height;

    console.log(playerSize, "playerSize");

    // Update video dimensions on window resize
    useEffect(() => {
        if (playerSize?.width && playerSize?.height) {
            setVideoSize({ videoWidth: videoWidth, videoHeight: videoHeight });
        }
    }, [playerSize]);

    const videoDimensions = () => {
        // Use dynamic window dimensions rather than hardcoded values
        return { videoWidth: videoSize.videoWidth, videoHeight: videoSize.videoHeight };
    };

    console.log("csknskcnskcnk", videoSize);

    const {
        data: videoBlurMaskingData,
        error: videoBlurMaskingError,
        loading: videoBlurMaskingLoading,
        fetchData: videoBlurMaskingRequestData,
    } = useApiError<any>(`${API_ENDPOINTS.videoBlur.USERDATA_MASKING}`, "POST"
    );

    const {
        data: iotDeviceByDeviceIdData,
        error: iotDeviceByDeviceIdError,
        loading: iotDeviceByDeviceIdLoading,
        fetchData: iotDeviceByDeviceIdRequestData,
    } = useApiError<any>(`${API_ENDPOINTS.videoBlur.IOT_DEVICE_BY_DEVICE_ID}/${deviceId}`, "GET"
    );

    // useEffect(() => {
    //     const fetchUserData = async () => {
    //         try {
    //             const userData = await getUserDataForMaskingReact(deviceId);
    //             const blurValue = userData.data.blur;

    //             if (blurValue) {
    //                 setApplyOverlay(true);
    //             } else {
    //                 const deviceData = await FcwIotDeviceByDeviceId(deviceId);
    //                 const blurStatus = deviceData.data.blurStatus;
    //                 setApplyOverlay(blurStatus);
    //             }
    //         } catch (err) {
    //             console.error("Error fetching user data:", err);
    //         } finally {
    //             onOverlayReady(); // Always call to make video player visible
    //         }
    //     };

    //     fetchUserData();
    // }, [deviceId]);

    const fetchIotDeviceByDeviceId = async () => {
        const deviceData = await iotDeviceByDeviceIdRequestData(deviceId);
        console.log("deviceData yashxx---------", deviceData);

        const blurStatus = deviceData?.data?.blurStatus;
        setBlurStatus(blurStatus);
        setApplyOverlay(blurStatus);
    }

    useEffect(() => {
        const fetchUserData = async () => {
            console.log('overlay 96 makeing false yashxx');
            
            onOverlayReady(blurEnable ? true : false);
            try {


                if (!fetchBlurFalse) {
                    const userData = await videoBlurMaskingRequestData({
                        fleetId: user?.customer_id || customerId,
                    });
                    console.log("userData ---------", userData);

                    const blurValue = userData?.data?.blur?.enableFlag;
                    console.log("blurValue ---------", blurValue);
                    if (blurValue) {
                        console.log("blurValue setting ---------", blurValue);
                        setBlurStatus(blurValue);
                        setApplyOverlay(blurValue);
                    } else {
                        fetchIotDeviceByDeviceId()
                        console.log("blurValue setting false ---------", blurValue);
                    }
                } else {
                     // Notify that overlay is ready
                    if (blurEnable) {
                       fetchIotDeviceByDeviceId()
                    }
                }
                // onOverlayReady(); // Notify that overlay is ready
            } catch (error) {
                console.error("Error fetching or adjusting overlay:", error);
                alert("Failed to fetch data. Please try again.");
            }
        };

        fetchUserData();
    }, [deviceId]);

    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            const fullscreenElement = document.fullscreenElement || document.fullscreenElement || document.fullscreenElement || document.fullscreenElement;
            setIsFullscreen(!!fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, [isFullscreen]);


    useEffect(() => {
        const fetchAndAdjustOverlay = async (mlParams: any) => {
            console.log("mlParams yashxx", mlParams);
            console.log("applyOverlay yashxx", applyOverlay, availableWidth);

            if(blurEnable) {
                setApplyOverlay(true);
            }
            
            if (!applyOverlay || !mlParams) return;

            try {
                const { videoWidth, videoHeight } = videoDimensions();
                const dsmCabin = mlParams?.data?.data.dsmCabin;

                if (dsmCabin) {
                    const { dsm_cabin_driver_crop_x: cropX, dsm_cabin_driver_crop_y: cropY, dsm_cabin_driver_crop_width: cropWidth, dsm_cabin_driver_crop_height: cropHeight } = dsmCabin;

                    if (cropX != null && cropY != null && cropWidth != null && cropHeight != null) {
                        let targetWidth = 1280;
                        let targetHeight = 720;

                        if (deviceType === 'vp2') {
                            targetWidth = 640;
                            targetHeight = 360;
                        }

                        console.log(videoWidth, videoHeight, targetWidth, targetHeight, deviceType, 'scndknckdnckdnckdnckdcn');

                        const scaleX = targetWidth / videoWidth;
                        const scaleY = targetHeight / videoHeight;

                        const mappedX = cropX / scaleX;
                        const mappedY = cropY / scaleY;
                        const mappedWidth = cropWidth / scaleX;
                        const mappedHeight = cropHeight / scaleY;

                        const sections: OverlaySection[] = [
                            { top: 0, left: 0, width: videoWidth, height: mappedY },
                            { top: mappedY, left: 0, width: mappedX, height: mappedHeight },
                            { top: mappedY, left: mappedX + mappedWidth, width: videoWidth - (mappedX + mappedWidth), height: mappedHeight },
                            { top: mappedY + mappedHeight, left: 0, width: videoWidth, height: videoHeight - (mappedY + mappedHeight) }
                        ];

                        setOverlaySections(sections);
                    }
                }
                console.log("Overlay sections: yashxx", overlaySections);

                onOverlayReady(true); // Notify that overlay is ready
            } catch (error) {
                console.error("Error fetching or adjusting overlay:", error);
                alert("Failed to fetch data. Please try again.");
            }
        };

        fetchAndAdjustOverlay(mlParams);
    }, [deviceId, applyOverlay, videoSize, availableWidth, mlParams, fullMode]);

    console.log("Device ID in VideoOverlay:", overlaySections);

    return (
        <div
            className={`${isFullscreen
                ? 'fixed left-0 right-0 top-0 bottom-0 w-full h-full z-50'
                : 'absolute left-0 right-0 top-0 bottom-0'
                } ${tableBlur ? 'rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-lg top-3 left-3 right-3 bottom-3' : ''}`}
        >

            {overlaySections.map((section, index) => (
                <div
                    key={index}
                    style={{
                        position: "absolute",
                        top: `${section.top}px`,
                        left: `${section.left}px`,
                        width: `${section.width}px`,
                        height: `${section.height}px`,
                        background: "rgba(0, 0, 0, 0.05)",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        pointerEvents: "none",
                        zIndex: 10
                    }}
                ></div>
            ))}
            {/* {videoReady && (
                <video
                    src={streamUrl}
                    autoPlay
                    muted
                    loop
                    style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 5
                    }}
                />
            )} */}
        </div>
    );
}

export default VideoOverlay;
